<template>
  <div
    :id="`vendor-progress-card-${detail.checklistRequestedId}`"
    class="tw-flex"
  >
    <div
      :class="[
        'tw-bg-[#FCFCFC] tw-max-h-[112px] tw-min-h-[112px] tw-h-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-l-md tw-border-solid tw-border-[#EFF0F1]',
        classStyleContent,
      ]"
    >
      <div class="tw-flex tw-flex-col tw-w-full tw-gap-[10px]">
        <div class="tw-flex tw-justify-between tw-items-center tw-w-full">
          <div
            :class="`${
              isGreyOut ? 'tw-text-[#878787]' : 'tw-text-[#211F58]'
            } tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title`"
          >
            {{
              getComponentUiText("app-component-assessment-title-progress-1")
            }}
          </div>
          <div
            v-if="loading"
            class="custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
          ></div>
          <div
            v-else
            :id="`vendor-progress-card-completion-${detail.checklistRequestedId}`"
            class="tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]"
          >
            {{ detail.completion.toFixed(0) }}/{{
              detail.completionMax.toFixed(0)
            }}
            <span class="tw-text-[#878787] tw-font-[500]"
              >{{ (detail.completionPcnt * 100).toFixed(0) }}%</span
            >
          </div>
        </div>

        <div class="tw-flex tw-justify-between tw-items-center tw-w-full">
          <div
            :class="`${
              isGreyOut ? 'tw-text-[#878787]' : 'tw-text-[#211F58]'
            } tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title`"
          >
            {{
              getComponentUiText(
                "app-component-assessments-question-type-2-icon-tooltip-score-1",
              )
            }}
          </div>
          <div
            v-if="loading"
            class="custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
          ></div>
          <div
            v-else
            :id="`vendor-progress-card-score-${detail.checklistRequestedId}`"
            class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
          >
            <div class="tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]">
              {{ detail?.score.toFixed(0) }}/{{ detail?.scoreMax }}
              <span class="tw-text-[#878787] tw-font-[500]"
                >{{ (detail.scorePcnt * 100).toFixed(0) }}%</span
              >
            </div>
          </div>
        </div>

        <div class="tw-flex tw-justify-between tw-items-center tw-w-full">
          <div
            :class="`${
              isGreyOut ? 'tw-text-[#878787]' : 'tw-text-[#211F58]'
            } tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title`"
          >
            {{
              getComponentUiText(
                "app-component-assessments-checklists-assessment-details-card-label-1",
              )
            }}
          </div>
          <div
            v-if="loading"
            class="custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
          ></div>
          <div
            v-else-if="detail.dateAdded"
            :id="`vendor-progress-card-dateAdded-${detail.checklistRequestedId}`"
            class="tw-text-[#878787] tw-text-[13px] tw-font-[400]"
          >
            {{ convertUTCTimeToLocalTime(detail.dateAdded) }}
            -
            {{
              new Intl.DateTimeFormat("vi-VN", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              }).format(new Date(detail.dateAdded))
            }}
          </div>
        </div>
      </div>
    </div>

    <div
      v-show="isShowRadial"
      :class="[
        'tw-flex tw-items-center tw-min-w-[70px] tw-justify-center sm:tw-p-[4px] 2xl:tw-p-[20px] tw-bg-[#FCFCFC] tw-max-h-[112px] tw-max-w-[112px] tw-rounded-r-md tw-border tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]',
        classStyleIcon,
      ]"
    >
      <div
        v-if="loading"
        class="custom-global-skeleton-pulse tw-w-[72px] tw-h-[72px] tw-rounded-[50%]"
      ></div>
      <RadialProgressBar
        v-else
        :id="`vendor-progress-card-radial-progress-${detail.checklistRequestedId}`"
        class="d-inline"
        :total-steps="100"
        :completed-steps="detail.completionPcnt * 100"
        :is-hide-progress="true"
        outer-stroke-color="#48A0FF"
        :inner-stroke-color="`${isGreyOut ? '#B7B7B7' : '#48A0FF'}`"
      />
    </div>
    <div
      v-show="!isShowRadial"
      :class="[
        'tw-flex tw-items-center tw-justify-center tw-pt-[55px] tw-p-[20px] tw-bg-[#ffffff] tw-max-w-[112px] tw-max-h-[112px] tw-rounded-r-md tw-border tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]',
        classStyleIcon,
      ]"
    >
      <VendorAssessmentScoreChart
        :current-score="Number(detail.scorePcnt)"
        :pcnt-score="Number(detail.scorePcnt)"
        :note-color="'#62BB47'"
        :current-score-color="
          Number(detail.scorePcnt) === 0 ? '#F7553C' : '#01893D'
        "
        :total-score-color="
          Number(detail.scorePcnt) === 0 ? '#FEE5E2' : '#D9EDE2'
        "
        :width="150"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getComponentUiText } from "@/utils/utilities";
import RadialProgressBar from "../prospect/prospectQuestions/componentTypes/radialProgressBar.vue";
import { ComputedRef, PropType, computed } from "vue";
import { CHECKLISTSTATUS } from "@/utils/constants";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import { IChecklistRequested } from "@/interfaces/vendor";
import VendorAssessmentScoreChart from "./vendorAssessmentScoreChart.vue";

const props = defineProps({
  detail: {
    type: Object as PropType<IChecklistRequested>,
    required: false,
    default: () => ({}),
  },
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
  classStyleContent: {
    type: String,
    default: "",
  },
  classStyleIcon: {
    type: String,
    default: "",
  },
});

const checklistInforDetail: ComputedRef<any> = computed(() => {
  return props.detail;
});

const isShowRadial = computed(() => {
  return checklistInforDetail.value.statusId !== CHECKLISTSTATUS.DONE;
});

const isGreyOut: ComputedRef<any> = computed(() => {
  return props.detail?.isArchived;
});
</script>
